/* eslint-disable react/jsx-no-bind */
/**
 * @file 侧边导航我的项目
 * @author sunyingying01
 */

import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {Dropdown, Tooltip, Divider} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import cx from 'classnames';
import ProjectSvg from '@assets/icons/project.svg';
import ProjectActionSvg from '@assets/icons/projectAction.svg';
import {RootStore, ProjectsListStore} from '@/stores';
import styles from './index.module.less';

interface IProps {
    store: {
        projectsListStore: ProjectsListStore;
        rootStore: RootStore;
    };
}

const Projects: React.FC<IProps> = props => {
    const projectsListStore = props.store.projectsListStore;
    const [projectOpen, setProjectOpen] = useState(false);

    const renderDropdownContent = () => {
        return (
            <div className={styles.dropdownMenuWrapper}>
                <div className={cx(styles.menuWrapper)}>
                    <div className={styles.projectIcon}>
                        <ProjectSvg />
                    </div>
                    <div className={styles.projectTitle}>
                        {projectsListStore.selectedProject?.projectsName || '我的项目'}
                    </div>
                </div>
                <>
                    <Divider className={styles.divider} />
                    <Tooltip
                        color="#000"
                        placement="right"
                        classNames={{root: styles.tooltipWrapper}}
                        title="Beta 版暂不支持创建新项目"
                    >
                        <div className={cx(styles.menuWrapper, styles.menuCreateWrapper)}>
                            <div className={styles.projectIcon}>
                                <PlusOutlined className={styles.projectTitle} />
                            </div>
                            <div className={styles.projectTitle}>
                                创建项目
                            </div>
                        </div>
                    </Tooltip>
                </>
            </div>
        );
    };

    return (
        <Dropdown
            trigger="click"
            placement="bottom"
            classNames={{root: styles.dropdownWrapper}}
            popupRender={renderDropdownContent}
            onOpenChange={(open: boolean) => {
                setProjectOpen(open);
            }}
        >
            <div className={cx(styles.projectWrapper, {[styles.projectWrapperActive]: projectOpen})}>
                <div className={styles.projectIcon}>
                    <ProjectSvg />
                </div>
                <div className={styles.projectRight}>
                    <div className={styles.projectTitle}>
                        我的项目
                    </div>
                    <div className={styles.projectActionIcon}>
                        <ProjectActionSvg />
                    </div>
                </div>
            </div>
        </Dropdown>
    );
};

export default observer(Projects);
